<script module lang="ts">
  import type { SerializedItemWithUserData } from '#inventory/lib/items'
  import type { EntityUri } from '#server/types/entity'

  export type ItemsByEditions = Record<EntityUri, SerializedItemWithUserData[]>

</script>
<script lang="ts">
  import Link from '#app/lib/components/link.svelte'
  import { getOwnersCountPerEdition, getCounterText } from '#entities/components/lib/edition_action_helpers'
  import type { SerializedEntity } from '#entities/lib/entities'
  import type { RelativeUrl } from '#server/types/common'
  import { I18n } from '#user/lib/i18n'

  const {
    entity,
    itemsByEditions = {},
  }: {
    entity: SerializedEntity
    itemsByEditions?: ItemsByEditions
  } = $props()

  const uri = $derived(entity.uri)
  const url = $derived(`/entity/${uri}/add` as RelativeUrl)
  const editionItems = $derived(itemsByEditions[uri])
</script>

<div class="edition-actions">
  <div class="add-to-my-inventory">
    <Link
      {url}
      text={I18n('add to my inventory')}
      icon="plus"
      classNames="action-button tiny-button"
    />
  </div>
  {#if editionItems && getOwnersCountPerEdition(editionItems)}
    <div class="link-wrapper">
      <!-- insert itemsLists deeplink -->
      <Link
        url={`/entity/${uri}`}
        text={getCounterText(editionItems)}
        dark={true}
      />
    </div>
  {/if}
</div>
<style lang="scss">
  @import "general/scss/utils";
  .edition-actions{
    @include display-flex(column, center, flex-end);
  }
  .add-to-my-inventory{
    :global(.action-button){
      @include tiny-button($light-blue);
      padding: 0.5em;
      white-space: nowrap;
    }
  }
  .link-wrapper{
    padding: 0.5em;
  }
  /* Small screens */
  @media screen and (width < $small-screen){
    .add-to-my-inventory{
      @include display-flex(row);
      margin-block-end: 0.5em;
    }
  }
</style>
